









































import { Component, Prop, Vue } from "vue-property-decorator";
import { ServerResult } from "@/core/http/server_result";

export const ITEMS_LIST = "AGENT_CLIENTS_LIST";

@Component
export default class AgentClientList extends Vue {
  @Prop() agentId!: string;

  documents = [];
  loading = false;
  lastMeta: any = {};

  loadData() {
    this.loading = true;

    (this as any)
      .$db([
        (this as any)
          .$q(ITEMS_LIST)
          .raw("documents.list")
          .action({
            columns: {
              id: "c.id",
              name: "c.name",
              city_name: "city.name"
            },
            from: "s:clients",
            from_as: "c",
            joins: [
              {
                join: "s:cities",
                type: "left",
                as: "city",
                on: {
                  $eq: ["c.city_id", "city.id"]
                }
              }
            ],
            page_size: 10000,
            where: {
              $eq: ["c.agent_id", { $: this.agentId }]
            }
          })
      ])
      .then((result: ServerResult) => {
        const opResult = result.getOperation(ITEMS_LIST).getContent();

        this.documents = opResult.documents;
        this.lastMeta = opResult.meta;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  // ---------------------------------------------------------------------------

  openDocument(row: any) {
    this.$router.push({
      name: "client-details",
      params: {
        id: row.id
      }
    });
  }

  // ---------------------------------------------------------------------------

  mounted() {
    this.loadData();
  }
}
